import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { getAdminUser } from '../utils/api';
import IncomeReport from './IncomeReport';
import LicenseExpiryReport from './LicenseExpiryReport';
import TreatmentSummary from './TreatmentSummary';
import DoctorFeeReport from './DoctorFeeReport';
import PatientStatistics from './PatientStatistics';

const Reports = () => {
  const { print_lang } = useLanguage();
  const [activeTab, setActiveTab] = useState('income');
  const user = getAdminUser();
  const isSuperAdmin = user?.is_super_admin || user?.admin_id === 1;

  const tabs = [
    { id: 'income', label: print_lang('reports.income', 'Income Report'), icon: 'M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
    { id: 'treatments', label: print_lang('reports.treatments', 'Treatment Summary'), icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01' },
    { id: 'doctors', label: print_lang('reports.doctors', 'Doctor Fees'), icon: 'M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z' },
    { id: 'patients', label: print_lang('reports.patients', 'Patient Statistics'), icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' },
    ...(isSuperAdmin ? [{ id: 'license', label: print_lang('reports.license', 'License Expiry'), icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z' }] : [])
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'income':
        return <IncomeReport />;
      case 'treatments':
        return <TreatmentSummary />;
      case 'doctors':
        return <DoctorFeeReport />;
      case 'patients':
        return <PatientStatistics />;
      case 'license':
        return isSuperAdmin ? <LicenseExpiryReport /> : null;
      default:
        return <IncomeReport />;
    }
  };

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">{print_lang('nav.reports', 'Reports')}</h1>
      </div>

      {/* Tab Navigation */}
      <div className="card" style={{ marginBottom: '1rem', padding: '0.5rem' }}>
        <div className="report-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`btn ${activeTab === tab.id ? 'btn-primary' : 'btn-outline'}`}
              style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d={tab.icon} />
              </svg>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      {renderTabContent()}
    </div>
  );
};

export default Reports;
